/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import React          from 'react';
import Popover        from 'components/Popover/Popover.react';
import history from 'dashboard/history';
import Button         from 'components/Button/Button.react';
import styles         from 'components/FourOhFour/FourOhFour.scss';


//TODO: @pivanov - if there is no history go to "/apps"
export default function FourOhFour(props) {
  return(
    <Popover modal={true}>
      <div className={styles.fourOhFour}>
        <div className={styles.code}>
          <div style={{color: 'grey'}}>
            // 404 page not found.
          </div>
          <div>
            <span style={{color: '#bf616a'}}>if </span>{'\u0028\u0021'}<span>found</span>{'\u0029\u007B'}
          </div>
          <div>
            <span style={{paddingLeft: '15px', color: '#0092ff'}}>throw</span>{'\u0028'}<span style={{color: '#a6a61f'}}>"404. That's an error."</span>{'\u0029'}
          </div>
          <div>
            {'\u007D'}
          </div>
          <div>
            <Button
              value={'Go Back'}
              color={'green'}
              onClick={() => history.goBack()}
            />
          </div>
        </div>
      </div>
    </Popover>
  );
}
